import React, { useState, useRef, useEffect } from 'react';

import useResources from 'components/Common/Resources/Hooks/useResources';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Masonry from 'react-responsive-masonry';
import Card from 'components/Managers/Resources/Card';
import Filters from 'components/Managers/Resources/Filters';
import Header from './Header';

const useSize = (target) => {
  const [size, setSize] = useState(null);

  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      setSize(entry.contentRect);
    });
  });

  useEffect(() => {
    if (target.current) {
      setSize(target.current.getBoundingClientRect());
      resizeObserver.observe(target.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [target.current]);

  return size;
};

export default function Resources() {
  const { resources } = useResources();

  const [keyword, setKeyword] = useState('');
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [countColumns, setCountColumns] = useState(2);
  const wrapper = useRef(null);
  const size = useSize(wrapper);

  useEffect(() => {
    if (size) {
      if (size.width < 576) {
        setCountColumns(1);
      } else {
        setCountColumns(2);
      }
    }
  }, [size]);

  if (resources === null) {
    return (
      <LoadingPlaceholder text="Loading..." className="pb-5 pt-5" />
    );
  }

  const promoteResource = resources.find((item) => item.attributes.manager_promote);

  const filteredResources = resources
    && Object.values(resources).filter((item) => {
      let available = false;
      if (
        item.attributes.title
          .toLowerCase()
          .includes(keyword.toLowerCase())
        && item.id !== promoteResource?.id
        && (selectedCategories.some((element) => item.attributes.categories.includes(element))
           || selectedCategories.length === 0)
      ) { available = true; }

      return available;
    });

  const checkCategory = (value) => {
    if (selectedCategories.includes(value)) {
      setSelectedCategories(selectedCategories.filter((item) => item !== value));
    } else {
      setSelectedCategories([...selectedCategories, value]);
    }
  };

  const categories = [...new Set(resources.map((item) => item.attributes.categories).flat())];

  return (
    <>
      <Header className={size !== null && size.width < 750 ? 'flex-column' : 'flex-row'} resource={promoteResource} />
      <section ref={wrapper}>
        <Filters
          setKeyword={setKeyword}
          checkCategory={checkCategory}
          categories={categories}
        />

        <Masonry columnsCount={countColumns} gutter="1rem">
          {filteredResources.map((resource) => (
            <div key={resource.id} className={`mb-3 ${size !== null && size.width < 750 ? 'vertical' : ''}`}>
              <Card resource={resource} className={size !== null && size.width < 750 ? 'vertical' : ''} />
            </div>
          ))}
        </Masonry>

      </section>
    </>
  );
}
